/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespContainerNotListed_viewer = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainerNotListed_viewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSeoLinks_viewer",
      "args": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
